var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player"},[_c('div',{class:{indicator: true, play: _vm.is_playing},style:({animationDuration: (_vm.duration + "s")})})])}
var staticRenderFns = []

export { render, staticRenderFns }